module.exports = __webpack_public_path__ + "img/no_search.a7c5f937.png";